import {getDistance, IPoint, mixPoints, reflectPoint} from "./geometry";
import {clamp01, lerp} from "./math";

export interface IArcLengthPath {
    length: number;
    waypointFractions: number[];
    pointAt: (fraction: number) => IPoint;
}

const CENTRIPETAL_ALPHA = 0.5;
const ARC_LENGTH_SAMPLES_PER_SEGMENT = 200;
const MIN_KNOT_DISTANCE = 1e-6;

export const createCatmullRomPath = (waypoints: IPoint[]): IArcLengthPath => {
    if (waypoints.length < 2) {
        const only = waypoints[0] ?? {x: 0, y: 0};

        return {length: 0, waypointFractions: waypoints.map(() => 0), pointAt: () => ({...only})};
    }

    const points = [reflectPoint(waypoints[0], waypoints[1]), ...waypoints, reflectPoint(waypoints[waypoints.length - 1], waypoints[waypoints.length - 2])];
    const knots = points.reduce<number[]>((acc, point, index) => {
        if (index === 0) {
            return [0];
        }

        return [...acc, acc[index - 1] + Math.max(getDistance(points[index - 1], point), MIN_KNOT_DISTANCE) ** CENTRIPETAL_ALPHA];
    }, []);
    const segmentCount = waypoints.length - 1;

    const evaluateAt = (t: number): IPoint => {
        let segment = 0;

        while (segment < segmentCount - 1 && t > knots[segment + 2]) {
            segment++;
        }

        const [p0, p1, p2, p3] = points.slice(segment, segment + 4);
        const [t0, t1, t2, t3] = knots.slice(segment, segment + 4);

        const a1 = mixPoints(p0, p1, (t - t0) / (t1 - t0));
        const a2 = mixPoints(p1, p2, (t - t1) / (t2 - t1));
        const a3 = mixPoints(p2, p3, (t - t2) / (t3 - t2));
        const b1 = mixPoints(a1, a2, (t - t0) / (t2 - t0));
        const b2 = mixPoints(a2, a3, (t - t1) / (t3 - t1));

        return mixPoints(b1, b2, (t - t1) / (t2 - t1));
    };

    const tableT: number[] = [knots[1]];
    const tableLength: number[] = [0];
    const waypointFractions: number[] = [0];
    let previous = evaluateAt(knots[1]);
    let accumulated = 0;

    for (let segment = 0; segment < segmentCount; segment++) {
        const from = knots[segment + 1];
        const to = knots[segment + 2];

        for (let step = 1; step <= ARC_LENGTH_SAMPLES_PER_SEGMENT; step++) {
            const t = lerp(from, to, step / ARC_LENGTH_SAMPLES_PER_SEGMENT);
            const point = evaluateAt(t);

            accumulated += getDistance(previous, point);
            previous = point;
            tableT.push(t);
            tableLength.push(accumulated);
        }

        waypointFractions.push(accumulated);
    }

    const length = accumulated;

    const pointAt = (fraction: number): IPoint => {
        const target = clamp01(fraction) * length;
        let low = 1;
        let high = tableLength.length - 1;

        while (low < high) {
            const middle = (low + high) >> 1;

            if (tableLength[middle] < target) {
                low = middle + 1;
            } else {
                high = middle;
            }
        }

        const span = tableLength[low] - tableLength[low - 1];
        const ratio = span > 0 ? (target - tableLength[low - 1]) / span : 0;

        return evaluateAt(lerp(tableT[low - 1], tableT[low], ratio));
    };

    return {length, waypointFractions: waypointFractions.map((value) => (length > 0 ? value / length : 0)), pointAt};
};
import {getDistance, IPoint, mixPoints, reflectPoint} from "./geometry";
import {clamp01, lerp} from "./math";

export interface IArcLengthPath {
    length: number;
    waypointFractions: number[];
    pointAt: (fraction: number) => IPoint;
}

const CENTRIPETAL_ALPHA = 0.5;
const ARC_LENGTH_SAMPLES_PER_SEGMENT = 200;
const MIN_KNOT_DISTANCE = 1e-6;

export const createCatmullRomPath = (waypoints: IPoint[]): IArcLengthPath => {
    if (waypoints.length < 2) {
        const only = waypoints[0] ?? {x: 0, y: 0};

        return {length: 0, waypointFractions: waypoints.map(() => 0), pointAt: () => ({...only})};
    }

    const points = [reflectPoint(waypoints[0], waypoints[1]), ...waypoints, reflectPoint(waypoints[waypoints.length - 1], waypoints[waypoints.length - 2])];
    const knots = points.reduce<number[]>((acc, point, index) => {
        if (index === 0) {
            return [0];
        }

        return [...acc, acc[index - 1] + Math.max(getDistance(points[index - 1], point), MIN_KNOT_DISTANCE) ** CENTRIPETAL_ALPHA];
    }, []);
    const segmentCount = waypoints.length - 1;

    const evaluateAt = (t: number): IPoint => {
        let segment = 0;

        while (segment < segmentCount - 1 && t > knots[segment + 2]) {
            segment++;
        }

        const [p0, p1, p2, p3] = points.slice(segment, segment + 4);
        const [t0, t1, t2, t3] = knots.slice(segment, segment + 4);

        const a1 = mixPoints(p0, p1, (t - t0) / (t1 - t0));
        const a2 = mixPoints(p1, p2, (t - t1) / (t2 - t1));
        const a3 = mixPoints(p2, p3, (t - t2) / (t3 - t2));
        const b1 = mixPoints(a1, a2, (t - t0) / (t2 - t0));
        const b2 = mixPoints(a2, a3, (t - t1) / (t3 - t1));

        return mixPoints(b1, b2, (t - t1) / (t2 - t1));
    };

    const tableT: number[] = [knots[1]];
    const tableLength: number[] = [0];
    const waypointFractions: number[] = [0];
    let previous = evaluateAt(knots[1]);
    let accumulated = 0;

    for (let segment = 0; segment < segmentCount; segment++) {
        const from = knots[segment + 1];
        const to = knots[segment + 2];

        for (let step = 1; step <= ARC_LENGTH_SAMPLES_PER_SEGMENT; step++) {
            const t = lerp(from, to, step / ARC_LENGTH_SAMPLES_PER_SEGMENT);
            const point = evaluateAt(t);

            accumulated += getDistance(previous, point);
            previous = point;
            tableT.push(t);
            tableLength.push(accumulated);
        }

        waypointFractions.push(accumulated);
    }

    const length = accumulated;

    const pointAt = (fraction: number): IPoint => {
        const target = clamp01(fraction) * length;
        let low = 1;
        let high = tableLength.length - 1;

        while (low < high) {
            const middle = (low + high) >> 1;

            if (tableLength[middle] < target) {
                low = middle + 1;
            } else {
                high = middle;
            }
        }

        const span = tableLength[low] - tableLength[low - 1];
        const ratio = span > 0 ? (target - tableLength[low - 1]) / span : 0;

        return evaluateAt(lerp(tableT[low - 1], tableT[low], ratio));
    };

    return {length, waypointFractions: waypointFractions.map((value) => (length > 0 ? value / length : 0)), pointAt};
};
